"use client";

import { FriendMatchHubPage } from "@/features/friend/FriendMatchHubPage";

export default function PlayFriendPage() {
  return <FriendMatchHubPage />;
}
